import { render, staticRenderFns } from "./documents.accountspayable.PND50to55.vue?vue&type=template&id=15c9c63f&scoped=true"
import script from "./documents.accountspayable.PND50to55.vue?vue&type=script&lang=js"
export * from "./documents.accountspayable.PND50to55.vue?vue&type=script&lang=js"
import style0 from "./documents.accountspayable.PND50to55.vue?vue&type=style&index=0&id=15c9c63f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c9c63f",
  null
  
)

export default component.exports